<ng-template #content let-modal>
  @if (detailsA()) {
    <div class="modal-header">
      <h2 class="modal-title" id="modal-basic-title">
        {{ 'compromise-reports-title-details' | translate }} {{ attestationCourante?.id }}
      </h2>
      <button type="button" class="modal-close" aria-label="Close"
        (click)="modal.dismiss('Cross click'); resetModal()"></button>
    </div>
    <div class="modal-body justify-content-center">
      <app-modalpart
        [attestation]="true"
        [objetCourant]="attestationCourante"
        (eventMetadata)="setMetadata($event); detailsA.set(false); ldetectorsprobes.set(undefined)"
        (filtreApp)="modal.close('Save click'); getApp($event); resetModal()">
      </app-modalpart>
      <app-score-details
        [scoreCourant]="attestationCourante?.score_prevention"
        (familyName)="detailsA.set(false); listDP.set(true); getAllProbesDetectors($event.toLowerCase()); setFamilyselected($event)">
      </app-score-details>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark"
        (click)="modal.close('Save click')">{{ 'back-to-list' | translate }}</button>
    </div>
  } @else {
    @if (ldetectorsprobes()) {
      <div class="modal-header">
        <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="backModal()">
          <button></button>
          <h3>{{ 'back' | translate }}</h3>
        </div>
        <h2 class="modal-title" id="modal-basic-title2">{{ formatTitlePDProbes() }}</h2>
        <button type="button" class="modal-close" aria-label="Close"
          (click)="modal.dismiss('Cross click'); resetModal()"></button>
      </div>
      <div class="modal-body justify-content-center">
        <app-commons-modal-part
          [listContent]="dpdetails()"
          [mapObject]="ldetectorsprobes()"
          (probesDetailsTitle)="detailsprobestitle = $event"
          (dpactif)="dpdetails.set($event)">
        </app-commons-modal-part>
      </div>
    }
    @if (metadata()) {
      <div class="modal-header">
        <div class="d-flex flex-row align-items-center modal-back" type="button" (click)="backModal()">
          <button></button>
          <h3>{{ 'back' | translate }}</h3>
        </div>
        <h2 class="modal-title" id="modal-basic-title2">
          {{ 'attestations-title-metadata' | translate }}
        </h2>
        <button type="button" class="modal-close" aria-label="Close"
          (click)="modal.dismiss('Cross click'); resetModal()"></button>
      </div>
      <div class="modal-body justify-content-center">
        <app-commons-modal-part [mapObject]="metadata()"></app-commons-modal-part>
      </div>
    }
  }

</ng-template>

<button class="btn btn-lg btn-outline-primary"
  (click)="open({ content: content })">{{ 'attestations-see-the-attestation' | translate }}</button>